
import { Component, ElementRef, AfterViewInit } from '@angular/core';
import gsap from 'gsap';

@Component({
  selector: 'app-animated-svg',
  standalone: true,
  templateUrl: './animated-svg.component.html',
  styleUrls: ["../../styles/inventory.css"]
})
export class AnimatedSvgComponent implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const circles: NodeListOf<SVGCircleElement> = this.el.nativeElement.querySelectorAll('circle');

    circles.forEach(circle => {
      const cx = parseFloat(circle.getAttribute('cx') || '0');
      const cy = parseFloat(circle.getAttribute('cy') || '0');

      // Store original position
      circle.dataset['originCx'] = cx.toString();
      circle.dataset['originCy'] = cy.toString();

      this.animateCircle(circle);
    });
  }

  animateCircle(circle: SVGCircleElement): void {
    const originCx = parseFloat(circle.dataset['originCx'] || '0');
    const originCy = parseFloat(circle.dataset['originCy'] || '0');

    const newCx = originCx + gsap.utils.random(-30, 30);
    const newCy = originCy + gsap.utils.random(-20, 20);
    const duration = gsap.utils.random(1, 1.5); 

    gsap.to(circle, {
      attr: { cx: newCx, cy: newCy },
      duration,
      ease: 'sine.inOut',
      onComplete: () => this.animateCircle(circle),
    });
  }
}
